module.exports = __webpack_public_path__ + "static/stage-d2d5547e551fd58f8e61c12b1338da5d.jpg";